/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef, useContext} from 'react';
import {TableWrapperContext} from '../TableWrapper';
import css from '../../../../styles/FacebookStatistics.module.scss';
import classNames from 'classnames';
import {useStore} from '../../../../store/store';
import {observer} from 'mobx-react';
import {useResolvedThemeMode} from '../../../hooks/useResolvedThemeMode';
import Navigation from '../../../modules/NavigationBloggers';
import Filter from './Filter';
import FilterOfFilters from './FilterOfFilters';
import SearchableParams from '../SearchableParams';

const Filters = ({
  facebookStatisticsGroups,
  facebookStatisticsFilters,
  childrenHead,
  childrenNearGroups = <></>,
  childrenByFilters = <></>,
  childrenPresets,
  childrenRefresh,
  linksForOnGroup = null,
  speedNavigation = null,
}) => {
  const store = useStore();
  const themeMode = useResolvedThemeMode();

  const {
    changeListGroups,
    changeListFilters,
    activeFiltersForFiltersRef,
    activeGroupsForFiltersRef,
    filterData,
    defaultGroups,
    hasHiddenGroups,
    defaultFilters,
    CalendarForFullScreen,
    fullMode,
  } = useContext(TableWrapperContext);

  const [filterListFilters, setFilterListFilters] = useState([]);
  const [selectedFiltersForRow, setSelectedFiltersForRow] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]); //головний обєкт для роботи із запитами

  const [oneGroup, setOneGroup] = useState('');
  const [groupsList, setGroupsList] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]); //головний обєкт для роботи із запитами

  //Filters *Start*///////////////////

  useEffect(() => {
    //filters
    const result = [];
    Object.keys(activeFiltersForFiltersRef).forEach((key) => {
      // Отримуємо значення фільтра як масив
      const filterValues = Array.isArray(activeFiltersForFiltersRef[key])
        ? activeFiltersForFiltersRef[key]
        : activeFiltersForFiltersRef[key] === ''
        ? []
        : [activeFiltersForFiltersRef[key]];

      // Знаходимо відповідний label з statisticsFilters
      let filterLabel = '';
      for (const group of facebookStatisticsFilters) {
        const found = group.options.find((opt) => opt.value === key);
        if (found) {
          filterLabel = found.label;
          break;
        }
      }

      // Формуємо масив опцій на основі значень з activeFilters

      const options = filterValues.map((val) => {
        // Знаходимо об’єкт у filterData для даного ключа, де id співпадає зі значенням
        if (!filterData[key]) return {value: '', label: ''};
        const optionData = filterData[key]?.find((item) => String(item.id) === String(val));
        //перевірка ID
        const isOnlyDigits =
          typeof val === 'number'
            ? val !== 0
            : typeof val === 'string' && /^\d+$/.test(val) && val !== '0';

        const baseName =
          optionData.name ||
          (optionData.first_name &&
            optionData.last_name &&
            `${optionData.first_name} ${optionData.last_name}`) ||
          optionData.username ||
          '';

        const label = isOnlyDigits ? `#${val} ${baseName}` : baseName;

        return {
          value: val,
          label,
        };
      });

      result.push({
        value: key,
        label: filterLabel,
        options: options,
      });
    });

    setSelectedFilters(result);
    setSelectedFiltersForRow(result);
    setFilterListFilters(createFilterOptions(Object.keys(activeFiltersForFiltersRef)));

    //groups
    const foundGroups = activeGroupsForFiltersRef
      .map((targetValue) => {
        for (const group of facebookStatisticsGroups) {
          const match = group.options.find((option) => option.value === targetValue);
          if (match) return match;
        }
        return null;
      })
      .filter(Boolean);

    setSelectedGroups(foundGroups);

    setGroupsList(createGroupsOptions(activeGroupsForFiltersRef));
    setOneGroup(!!activeGroupsForFiltersRef[0] ? activeGroupsForFiltersRef[0] : '');
  }, [activeFiltersForFiltersRef, activeGroupsForFiltersRef, filterData]);

  const convertFiltersToObject = (filters) => {
    const newFilters = {};
    filters.forEach((item) => {
      if (!item?.options || item?.options?.length === 0) {
        newFilters[item.value] = '';
      } else if (item?.options.length === 1) {
        newFilters[item.value] = item?.options[0].value;
      } else {
        newFilters[item.value] = item?.options.map((el) => el.value);
      }
    });

    return newFilters;
  };

  const createFilterOptions = (arrSelectedFilters) => {
    const filtersList = structuredClone(facebookStatisticsFilters).map((item) => {
      item.options = item.options.filter((item) => {
        if (!arrSelectedFilters?.includes(item.value)) {
          if ((store.roles.includes(6) || store.roles.includes(7)) && item.value !== 'bayer_id') {
            return item;
          }
          return item;
        }
      });
      return item;
    });
    const cleanFilterList = filtersList.filter((item) => item.options.length > 0);

    return cleanFilterList;
  };

  const addFilterToSelected = (item) => {
    const newSelectedFilters = structuredClone(selectedFilters);
    newSelectedFilters.push(item);
    setSelectedFilters(newSelectedFilters);
    setFilterListFilters(createFilterOptions(newSelectedFilters.map((item) => item.value)));
    changeListFilters(convertFiltersToObject(newSelectedFilters), true);
  };

  const removeFilter = (indexFilter, type = '') => {
    const newSelectedFilters = structuredClone(selectedFilters);
    //шукаємо фільтри по яким був пошук
    const match = selectedFiltersForRow.find(
      (group) =>
        group.value === newSelectedFilters[indexFilter].value ||
        group.label === newSelectedFilters[indexFilter].label
    );

    if (type === 'forRow') {
      newSelectedFilters[indexFilter].options = [];
    } else {
      newSelectedFilters.splice(indexFilter, 1);
      setFilterListFilters(createFilterOptions(newSelectedFilters.map((item) => item.value)));
    }

    setSelectedFilters(newSelectedFilters);
    if (!match) return;
    setSelectedFiltersForRow(newSelectedFilters);
    changeListFilters(convertFiltersToObject(newSelectedFilters));
  };

  const removeFiltersOption = (indexFilter, indexOption) => {
    const newSelectedFilters = structuredClone(selectedFilters);
    //шукаємо фільтри по яким був пошук
    const match = selectedFiltersForRow.find((group) =>
      group.options?.some(
        (opt) =>
          opt.value === newSelectedFilters[indexFilter].options[indexOption].value ||
          opt.label === newSelectedFilters[indexFilter].options[indexOption].label
      )
    );

    newSelectedFilters[indexFilter].options.splice(indexOption, 1);
    setSelectedFilters(newSelectedFilters);
    if (!match) return;
    setSelectedFiltersForRow(newSelectedFilters);
    setFilterListFilters(createFilterOptions(newSelectedFilters.map((item) => item.value)));
    changeListFilters(convertFiltersToObject(newSelectedFilters));
  };

  const searchByFilters = (item) => {
    const newSelectedFilters = structuredClone(selectedFiltersForRow);
    const findIndexSelectedFilter = newSelectedFilters.findIndex((s) => s.value === item.value);
    if (findIndexSelectedFilter !== -1) {
      newSelectedFilters.splice(findIndexSelectedFilter, 1, item);
    } else {
      newSelectedFilters.push(item);
    }
    setSelectedFiltersForRow(newSelectedFilters);
    changeListFilters(convertFiltersToObject(newSelectedFilters));
  };

  //Filters *End*///////////////////

  //Groups *Start*/////////////////
  const createGroupsOptions = (arrSelectedGroups) => {
    const groupsList = structuredClone(facebookStatisticsGroups).map((item) => {
      item.options = item.options.filter((item) => {
        if (!arrSelectedGroups?.includes(item.value)) {
          if ((store.roles.includes(6) || store.roles.includes(7)) && item.value !== 'bayer') {
            return item;
          }
          return item;
        }
      });
      return item;
    });
    const cleanGroupsList = groupsList.filter((item) => item.options.length > 0);

    return cleanGroupsList;
  };

  const addGroup = (item) => {
    const newSelectedGroups = structuredClone(selectedGroups);
    if (newSelectedGroups.length === 0) {
      setOneGroup(item.value);
    }
    newSelectedGroups.push(item);
    setSelectedGroups(newSelectedGroups);
    setGroupsList(createGroupsOptions(newSelectedGroups.map((item) => item.value)));
    changeListGroups(newSelectedGroups, convertFiltersToObject(selectedFilters));
  };

  const removeGroup = (itemIndex) => {
    const newSelectedGroups = structuredClone(selectedGroups);
    newSelectedGroups.splice(itemIndex, 1);
    setSelectedGroups(newSelectedGroups);
    setGroupsList(createGroupsOptions(newSelectedGroups.map((item) => item.value)));
    if (itemIndex === 0) {
      setOneGroup('');
    }
    changeListGroups(newSelectedGroups, convertFiltersToObject(selectedFilters));
  };

  const selectedOneGroup = (item) => {
    if (item.link === '') {
      setSelectedGroups([]);
      setGroupsList(createGroupsOptions());
      changeListGroups([], convertFiltersToObject(selectedFilters));
    } else {
      setSelectedGroups([{value: item.link, label: item.title}]);
      setGroupsList(
        createGroupsOptions([{value: item.link, label: item.title}].map((item) => item.value))
      );
      changeListGroups(
        [{value: item.link, label: item.title}],
        convertFiltersToObject(selectedFilters)
      );
    }
  };
  //Groups *End*/////////////////

  return (
    <div
      className={css.filtersContainer}
      id='table_filters'
      style={{
        '--bgColor': themeMode === 'dark' ? '#1B1C22' : '#F9F9F9',
        '--borderColor': themeMode === 'dark' ? 'hsl(0, 0%, 20%)' : 'hsl(0, 0%, 80%)',
        '--closeColor': themeMode === 'dark' ? 'hsl(0, 0%, 80%)' : 'hsl(0, 0%, 20%)',
      }}
    >
      {(!!childrenHead || !!childrenRefresh || !!linksForOnGroup || fullMode) && (
        <section className={css.row}>
          <div className={css.block_1}>
            {linksForOnGroup ? (
              <Navigation
                page={oneGroup}
                setPage={setOneGroup}
                action={selectedOneGroup}
                links={!!linksForOnGroup && linksForOnGroup}
              />
            ) : (
              childrenHead
            )}
          </div>
          <div className={css.block_3} style={{flexWrap: 'nowrap', gap: !fullMode ? '0px' : '8px'}}>
            {childrenRefresh}
            <div style={!fullMode ? {width: '0px', visibility: 'hidden', overflow: 'hidden'} : {}}>
              {CalendarForFullScreen()}
            </div>
          </div>
        </section>
      )}
      <section className={css.row}>
        <div className={css.block_2}>
          {[
            // Спочатку відбираємо елементи, які відповідають фіксованим фільтрам
            ...selectedFilters.filter((item) =>
              defaultFilters.some((fixed) => fixed.isFixed && fixed.filter === item.value)
            ),
            // Потім решта елементів
            ...selectedFilters.filter(
              (item) =>
                !defaultFilters.some((fixed) => fixed.isFixed && fixed.filter === item.value)
            ),
          ].map((item, index) => {
            // Перевіряємо, чи є даний елемент фіксованим
            const isFixed = defaultFilters.some(
              (fixed) => fixed.isFixed && fixed.filter === item.value
            );
            const isHidden = defaultFilters.some(
              (fixed) => fixed.isFixed && fixed.isHidden && fixed.filter === item.value
            );

            if (isHidden) return <React.Fragment key={item.value}></React.Fragment>;

            return (
              <div className={css.selectContainer} key={item.value}>
                <Filter
                  mode={themeMode}
                  filters={filterData}
                  item={item}
                  index={index}
                  search={searchByFilters}
                  setSelectedOptions={setSelectedFilters}
                  selectedOptions={selectedFilters}
                  deleteOption={removeFiltersOption}
                />
                {!isFixed && (
                  <div className={css.selectClose} onClick={() => removeFilter(index, '')}></div>
                )}
              </div>
            );
          })}
          <div className={css.filtersSelector}>
            <FilterOfFilters
              tabIndex={1}
              options={filterListFilters}
              addOption={addFilterToSelected}
              placeholder={'Добавить фильтр'}
              classButton={'addFilter'}
              mode={themeMode}
            />
          </div>
        </div>
        <div className={css.block_3}>{childrenByFilters}</div>
      </section>
      {!!selectedFiltersForRow &&
        selectedFiltersForRow?.length > 0 &&
        selectedFiltersForRow.reduce((acc, curr) => acc + (curr?.options?.length || 0), 0) > 0 && (
          <section className={css.row}>
            <div className={css.block_2}>
              <SearchableParams
                params={selectedFiltersForRow.filter((item) => {
                  const isHidden = defaultFilters.some(
                    (fixed) => fixed.isHidden && fixed.filter === item.value
                  );
                  return !isHidden;
                })}
                deleteSavedOption={removeFiltersOption}
                deleteOptions={(index) => removeFilter(index, 'forRow')}
              />
            </div>
          </section>
        )}
      <section className={classNames(css.row)}>
        <div className={css.groups}>
          {childrenNearGroups}

          {!hasHiddenGroups && (
            <>
              {selectedGroups.length > 0 && (
                <div className={css.list}>
                  {selectedGroups.map((el, i) => {
                    const findFixedGroup = defaultGroups.find((group) => el.value === group.group);
                    if (!!findFixedGroup && findFixedGroup.isFixed) {
                      return <React.Fragment key={el.label}></React.Fragment>;
                    }

                    return (
                      <React.Fragment key={el.label}>
                        <div className={css.element}>
                          <span className={css.elementName}>{el.label}</span>
                          <span className={css.elementRemove} onClick={() => removeGroup(i)}></span>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              )}
              {selectedGroups.length < 5 && (
                <div className={css.filtersSelector}>
                  <FilterOfFilters
                    tabIndex={2}
                    placeholder={'Добавить группу'}
                    options={groupsList}
                    addOption={addGroup}
                    classButton={'addGroup'}
                    mode={themeMode}
                  />
                </div>
              )}
            </>
          )}
        </div>
        <div className={css.block_3}>{childrenPresets}</div>
      </section>
    </div>
  );
};

export default observer(Filters);
